module.exports = __webpack_public_path__ + "img/vellum_glue_test.640390fc.gif";